import * as React from 'react'
import FormGroup from 'reactstrap/lib/FormGroup'
import Label from 'reactstrap/lib/Label'
import Input from 'reactstrap/lib/Input'
import { Button } from 'reactstrap'
import { useHistory } from 'react-router'
import routes from 'src/modules/Routing/routes'

const UserTableSubHeader = ({ filterText, onSearch }): React.ReactElement => {
  const history = useHistory();
  return (
    <div className="managers-table__sub-header">
      <FormGroup className="search-bar">
        <Label for="managers-search">Search</Label>
        <Input
          id="managers-search"
          type="search"
          name="search"
          placeholder="Find an user by its name or email."
          value={filterText}
          onChange={(e) => onSearch(e.target.value)}
        />
      </FormGroup>
      <Button className="btn btn-blue float-right" onClick={() => history.push(routes.ADMINUSERSADD)}>Add user</Button>
    </div>
  )
}

export default React.memo(UserTableSubHeader);



// WEBPACK FOOTER //
// ./src/modules/UserSettings/Users/components/UserTableSubHeader.tsx